import { render, staticRenderFns } from "./BlockType.vue?vue&type=template&id=10685f20&scoped=true&"
import script from "./BlockType.vue?vue&type=script&lang=js&"
export * from "./BlockType.vue?vue&type=script&lang=js&"
import style0 from "./BlockType.vue?vue&type=style&index=0&id=10685f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10685f20",
  null
  
)

export default component.exports